import { margin } from "@mui/system";
import "../CSS/itemAsientosPaulet.css";
import React, { useRef, useEffect, useState } from "react";
import ItemAsiento from "./ItemAsiento";
import Swal from "sweetalert2";

function ItemAsientosPaulet(props) {
  const {
    listaAsientos,
    setListaAsientos,
    listaAsientosRegistrados,
    maxAsientos,
    tipoEvento,
  } = props;
  var listaprueba = [];
  //const [listaAsientosRegistrados, setListaAsientosRegistrados] =
  useState(listaprueba);

  var reserved = false;
  const reservedSeats = ["A3", "A4", "F1", "F2", "F3"];
  let board = Array(16)
    .fill(0)
    .map((row) => new Array(29).fill(0));

  const handleSeatClick = (seatId) => {
    if (listaAsientos.includes(seatId)) {
      setListaAsientos((prevState) =>
        prevState.filter((seat) => seat !== seatId)
      );
    } else if (listaAsientos.length < maxAsientos) {
      setListaAsientos((prevState) => [...prevState, seatId]);
    } else {
      if (tipoEvento == "Colegiatura") {
        Swal.fire({
          icon: "warning",
          text:  "Solo puedes seleccionar " + (parseInt(maxAsientos)-1)  + " invitados",
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Solo puedes seleccionar " + maxAsientos + " asientos",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }
  };

  useEffect(() => {
    //console.log("TIPOEvento" + localStorage.getItem("apellidoLocal"));
    if (tipoEvento == "Colegiatura") {
      //console.log("tamaño" + listaAsientos.length);
      if (listaAsientos.length > 1) {
      }
    }
  }, [listaAsientos]);
  return (
    <div className="asientosPaulet">
      <div>
        <div className="escenario">ESCENARIO</div>
        <table className="table">
          {board.map((items, index) => {
            return (
              <tr
                style={{
                  position: "relative",
                }}
              >
                <p
                  className="letraInicial"
                  style={{
                    margin: "0px",
                    width: "20px",
                    height: "50px",
                    //backgroundColor: "red",
                    position: "absolute",
                    top: "50%",
                    margin: "-9px -50px 0px",
                  }}
                >
                  {String.fromCharCode(65 + index)}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </p>
                {items.map((subItems, indice) => {
                  if (
                    indice == 8 ||
                    indice == 9 ||
                    indice == 19 ||
                    indice == 20
                  ) {
                    return <th>&nbsp;&nbsp;&nbsp;&nbsp;</th>;
                  }
                  if (tipoEvento == "Colegiatura") {
                    if (localStorage.getItem("apellidoLocal") != "CDA" && localStorage.getItem("apellidoLocal") != "SECRETARIO") {
                      if (listaAsientos.length <= 0) {
                        if (indice <= 20) {
                          return (
                            <th>
                              <ItemAsiento
                                asiento={
                                  String.fromCharCode(65 + index) +
                                  (parseInt(indice) + 1)
                                }
                                selected={props.listaAsientos.includes(
                                  String.fromCharCode(65 + index) +
                                    (parseInt(indice) + 1)
                                )}
                                onClick={handleSeatClick}
                                reserved={true}
                              ></ItemAsiento>
                            </th>
                          );
                        }
                      }
                      if (listaAsientos.length >= 1) {
                        if (indice >= 20) {
                          return (
                            <th>
                              <ItemAsiento
                                asiento={
                                  String.fromCharCode(65 + index) +
                                  (parseInt(indice) + 1)
                                }
                                selected={props.listaAsientos.includes(
                                  String.fromCharCode(65 + index) +
                                    (parseInt(indice) + 1)
                                )}
                                onClick={handleSeatClick}
                                reserved={true}
                              ></ItemAsiento>
                            </th>
                          );
                        }
                      }
                    }
                  }

                  return (
                    <th>
                      <ItemAsiento
                        asiento={
                          String.fromCharCode(65 + index) +
                          (parseInt(indice) + 1)
                        }
                        selected={props.listaAsientos.includes(
                          String.fromCharCode(65 + index) +
                            (parseInt(indice) + 1)
                        )}
                        onClick={handleSeatClick}
                        reserved={listaAsientosRegistrados.includes(
                          String.fromCharCode(65 + index) +
                            (parseInt(indice) + 1)
                        )}
                      ></ItemAsiento>
                    </th>
                  );
                })}
                <p
                  className="letraInicial"
                  style={{
                    margin: "0px",
                    width: "20px",
                    height: "50px",
                    //backgroundColor: "red",
                    position: "absolute",
                    top: "50%",
                    margin: "-9px 10px 0px",
                  }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;{String.fromCharCode(65 + index)}
                </p>
              </tr>
            );
          })}
        </table>
      </div>
    </div>
  );
}

export default ItemAsientosPaulet;
